import { useAuth } from '@/app/_components'
import { SaveReportModal } from '@/app/features/reports/components/publish/save-report-modal'
import { useSaveReport } from '@/app/features/reports/hooks/use-save-report'
import BusyButton from '@/components/raytd/busy-button'
import { CheckIcon, DownloadIcon } from 'lucide-react'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ReportPermissions } from 'store/src/lib/services/types'

interface SaveReportButtonProps {
    revisionId: number
    isSaved: boolean
    canSave: boolean
    className?: string
    permissions?: ReportPermissions
    label?: string
    text?: string
}

export function SaveReportButton({
    revisionId,
    isSaved,
    canSave,
    className,
    permissions,
    label = 'Save',
    text = "You'll need to create a free account to save this report."
}: SaveReportButtonProps) {
    const { handleSave, isSaving } = useSaveReport({
        revisionId,
    })

    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleContinue = useCallback(() => {
        // handleSave();
        console.debug('handleContinue', permissions);
        if (permissions.guestHasAccount) {
            //redirect to login
            navigate('/login', { state: { from: location } });
        } else {
            //redirect to signup
            navigate('/signup', {
                state: {
                    from: location,
                    invite: {
                        token: 'redirect',
                        user: {
                            email: permissions.user.email,
                            first_name: permissions.user.first_name,
                            last_name: permissions.user.last_name,
                        }
                    }
                }
            });
        }

    }, [permissions]);

    if (!canSave && permissions?.isAnonymous) {
        // return null
        console.debug('Save report button disabled', { canSave, isSaved, isSaving });


        let message = text;
        
        if (permissions?.guestHasAccount) {
            message = `We've noticed you've already created an account.
            Please login to save this report.`
        }

        return (
            <SaveReportModal
                isOpen={false}
                onOpenChange={() => { }}
                onContinue={handleContinue}
                message={message}
                trigger={<BusyButton
                    variant={isSaved ? "outlinelight" : "default"}
                    // onClick={handleSave}
                    // onClick={handleContinue}
                    className={`flex flex-row items-center ${className}`}
                    busyText="Saving..."
                    isBusy={isSaving}
                    disabled={isSaved}
                >
                    {isSaved ? (
                        <><CheckIcon className="w-4 h-4 mr-1" />Saved</>
                    ) : (
                        <><DownloadIcon className="w-4 h-4 mr-1" />{label}</>
                    )}
                </BusyButton>}
            />
        );
    }

    return (
        <BusyButton
            variant={isSaved ? "outlinelight" : "default"}
            onClick={handleSave}
            className={`flex flex-row items-center ${className}`}
            busyText="Saving..."
            isBusy={isSaving}
            disabled={isSaved || !canSave}
        >
            {isSaved ? (
                <><CheckIcon className="w-4 h-4 mr-1" />Saved</>
            ) : (
                <><DownloadIcon className="w-4 h-4 mr-1" />Save</>
            )}
        </BusyButton>
    )
}